module.exports = "<div class=\"container90\">\n  <div class=\"logotipo\"></div>\n</div>\n"